import Vue from 'vue'

Vue.directive('ripple', {
  inserted: function (el, binding) {
    let color         = binding.value === undefined ? '#FFF' : binding.value
    el.style.position = 'relative'
    el.style.overflow = 'hidden'
    
    el.onclick = function (ev) {
      let circle = document.createElement('div')
      let offset = this.getBoundingClientRect()
      let x      = ev.pageX - offset.left - document.body.scrollLeft
      let y      = ev.pageY - offset.top - document.body.scrollTop
      circle.setAttribute('style', 'background: ' + color + '; width: 10px; height: 10px; opacity: 0; border-radius: 100em; position: absolute; top: ' + y + 'px; left: ' + x + 'px; animation: anka-ripple 0.8s 1 ease-in-out;')
      this.append(circle)
      ev.stopPropagation()
      setTimeout(function () {
        circle.parentNode.removeChild(circle)
      }, 400)
    }
  }
})

Vue.directive('click-outside', {
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn       = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
      if (compName) {
        warn += `Found in component '${compName}'`
      }
      
      console.warn(warn)
    }
    // Define Handler and cache it on the element
    const bubble           = binding.modifiers.bubble
    const handler          = e => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler
    
    // add Event Listeners
    document.addEventListener('click', handler)
  },
  
  unbind: function (el) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null
  }
})
